// extracted by mini-css-extract-plugin
module.exports = {"loadingCover":"-loading-cover-loadingCover-sfSpWM-"};